// @flow
import about, { type State as aboutState } from './modules/about';
import { reducer as absenteeBid, type State as absenteeBidState } from './modules/absenteeBid';
import addSearchAlert, { type State as addSearchAlertState } from './modules/addSearchAlert';
import analytics, { type State as analyticsState } from './modules/analytics';
import autoPopModal, { type State as autoPopModalState } from './modules/autoPopModal';
import bidCountDown, { type State as bidCountDownState } from './modules/bidCountDown';
import bidderBiddingInfoAll, { type State as bidderBiddingInfoAllState } from './modules/bidderBiddingInfoAll';
import bidderBiddingInfoUpcoming, {
    type State as bidderBiddingInfoUpcomingState,
} from './modules/bidderBiddingInfoUpcoming';
import bidderExists, { type State as bidderExistsState } from './modules/bidderExists';
import biddingInfo, { type State as biddingInfoState } from './modules/biddingInfo';
import bidHistory, { type State as bidHistoryState } from './modules/bidHistory';
import bidIncrements, { type State as bidIncrementsState } from './modules/bidIncrements';
import bidLimit, { type State as bidLimitState } from './modules/bidLimit';
import bidLimitExceeded, { type State as bidLimitExceededState } from './modules/bidLimitExceeded';
import browser, { type State as browserState } from './modules/browser';
import buyNow, { type State as buyNowState } from './modules/buyNow';
import catalog, { type State as catalogState } from './modules/catalog';
import catalogAd, { type State as catalogAdState } from './modules/catalogAd';
import catalogCurators, { type State as catalogCuratorsState } from './modules/catalogCurators';
import catalogDetail, { type State as catalogDetailState } from './modules/catalogDetail';
import catalogFeatured, { type State as catalogFeaturedState } from './modules/catalogFeatured';
import catalogItems, { type State as catalogItemsState } from './modules/catalogItems';
import catalogLocation, { type State as catalogLocationState } from './modules/catalogLocation';
import catalogRegistration, { type State as catalogRegistrationState } from './modules/catalogRegistration';
import catalogSearch, { type State as catalogSearchState } from './modules/catalogSearch';
import category, { type State as categoryState } from './modules/category';
import changePassword, { type State as changePasswordState } from './modules/changePassword';
import checkout, { type State as checkoutState } from './modules/checkout';
import cityStateSuggestion, { type State as cityStateSuggestionState } from './modules/cityStateSuggestion';
import codex, { type State as codexState } from './modules/codex';
import completeAccount, { type State as completeAccountState } from './modules/completeAccount';
import config, { type State as configState } from './modules/config';
import confirmPassword, { type State as confirmPasswordState } from './modules/confirmPassword';
import consent, { type State as consentState } from './modules/consent';
import consignment, { type State as consignmentState } from './modules/consignment';
import console, { type State as consoleState } from './modules/console';
import consoleBranding, { type State as consoleBrandingState } from './modules/consoleBranding';
import consoleMessages, { type State as consoleMessagesState } from './modules/consoleMessages';
import coverLots, { type State as coverLotsState } from './modules/coverLots';
import createAccount, { type State as createAccountState } from './modules/createAccount';
import creditCard, { type State as creditCardState } from './modules/creditCard';
import curatedCollection, { type State as curatedCollectionState } from './modules/curatedCollection';
import currency, { type State as currencyState } from './modules/currency';
import emailList, { type State as emailListState } from './modules/emailList';
import escrow, { type State as escrowState } from './modules/escrow';
import featuredCategories, { type State as featuredCategoriesState } from './modules/featuredCategories';
import feedback, { type State as feedbackState } from './modules/feedback';
import fetchBatch, { type State as fetchBatchState } from './modules/fetchBatch';
import followSeller, { type State as followSellerState } from './modules/followSeller';
import forgotPassword, { type State as forgotPasswordState } from './modules/forgotPassword';
import globalNotification, { type State as globalNotificationState } from './modules/globalNotification';
import googleOptimize, { type State as googleOptimizeState } from './modules/googleOptimize';
import headerSearchDropdown, { type State as headerSearchDropdownState } from './modules/headerSearchDropdown';
import healthcheck, { type State as healthcheckState } from './modules/healthcheck';
import home, { type State as homeState } from './modules/home';
import imageGalleryActiveImage, { type State as imageGalleryActiveImageState } from './modules/imageGalleryActiveImage';
import intl, { type State as intlState } from './modules/intl';
import item, { type State as itemState } from './modules/item';
import itemDetail, { type State as itemDetailState } from './modules/itemDetail';
import itemFacets, { type State as itemFacetsState } from './modules/itemFacets';
import itemShipping, { type State as itemShippingState } from './modules/itemShipping';
import landingPage, { type State as landingPageState } from './modules/landingPage';
import listingAgent, { type State as listingAgentState } from './modules/listingAgent';
import liveBid, { type State as liveBidState } from './modules/liveBid';
import liveCatalogStatus, { type State as liveCatalogStatusState } from './modules/liveCatalogStatus';
import liveItemStatus, { type State as liveItemStatusState } from './modules/liveItemStatus';
import loaded, { type State as loadedState } from './modules/loaded';
import location, { type State as locationState } from './modules/location';
import login, { type State as loginState } from './modules/login';
import makeOffer, { type State as makeOfferState } from './modules/makeOffer';
import modal, { type State as modalState } from './modules/modal';
import moreItemsFromCatalogIndex, {
    type State as moreItemsFromCatalogIndexState,
} from './modules/moreItemsFromCatalogIndex';
import notification, { type State as notificationState } from './modules/notification';
import { paginationCookiesReducer, paginationLocalStorageReducer } from './modules/pagination';
import passwordReset, { type State as passwordResetState } from './modules/passwordReset';
import payment, { type State as paymentState } from './modules/payment';
import paymentCustomer, { type State as paymentCustomerState } from './modules/paymentCustomer';
import recentItem, { type State as recentItemState } from './modules/recentItem';
import recommendedItem, { type State as recommendedItemState } from './modules/recommendedItem';
import registerForCatalog, { type State as registerForCatalogState } from './modules/registerForCatalog';
import retractBid, { type State as retractBidState } from './modules/retractBid';
import review, { type State as reviewState } from './modules/review';
import reviewStatus, { type State as reviewStatusState } from './modules/reviewStatus';
import route, { type State as routeState } from './modules/route';
import savedItemCount, { type State as savedItemCountState } from './modules/savedItemCount';
import savedSearch, { type State as savedSearchState } from './modules/savedSearch';
import savedSearchItem, { type State as savedSearchItemState } from './modules/savedSearchItem';
import saveItem, { type State as saveItemState } from './modules/saveItem';
import saveSearch, { type State as saveSearchState } from './modules/saveSearch';
import saveSearchCheck, { type State as saveSearchCheckState } from './modules/saveSearchCheck';
import search, { type State as searchState } from './modules/search';
import searchExclusions, { type State as searchExclusionsState } from './modules/searchExclusions';
import searchFacets, { type State as searchFacetsState } from './modules/searchFacets';
import searchPromoted, { type State as searchPromotedState } from './modules/searchPromoted';
import searchSuggestions, { type State as searchSuggestionsState } from './modules/searchSuggestions';
import seller, { type State as sellerState } from './modules/seller';
import sellerCatalogCounts, { type State as sellerCatalogCountsState } from './modules/sellerCatalogCounts';
import sellerDetail, { type State as sellerDetailState } from './modules/sellerDetail';
import sellerEndedCatalogs, { type State as sellerEndedCatalogsState } from './modules/sellerEndedCatalogs';
import sellerFollowerCount, { type State as sellerFollowerCountState } from './modules/sellerFollowerCount';
import sellerPreviewCatalogs, { type State as sellerPreviewCatalogsState } from './modules/sellerPreviewCatalogs';
import sellerRatings, { type State as sellerRatingsState } from './modules/sellerRatings';
import sellerRecordResults, { type State as sellerRecordResultsState } from './modules/sellerRecordResults';
import sellerUpcomingCatalogs, { type State as sellerUpcomingCatalogsState } from './modules/sellerUpcomingCatalogs';
import sendSellerMessage, { type State as sendSellerMessageState } from './modules/sendSellerMessage';
import setPassword, { type State as setPasswordState } from './modules/setPassword';
import { reducer as shim, type State as shimState } from './modules/shim';
import shipping, { type State as shippingState } from './modules/shipping';
import shouldLogin, { type State as shouldLoginState } from './modules/shouldLogin';
import similarItems, { type State as similarItemsState } from './modules/similarItems';
import similarItemsV3, { type State as similarItemsV3State } from './modules/similarItemsV3';
import storefront, { type State as storefrontState } from './modules/storefrontPage';
import stripe, { type State as stripeState } from './modules/stripe';
import topRatedSellers, { type State as topRatedSellersState } from './modules/topRatedSellers';
import trustMetrics, { type State as trustMetricsState } from './modules/trustMetrics';
import upcomingCatalogs, { type State as upcomingCatalogsState } from './modules/upcomingCatalogs';
import upcomingItems, { type State as upcomingItemsState } from './modules/upcomingItems';
import updateAccount, { type State as updateAccountState } from './modules/updateAccount';
import user, { type State as userState } from './modules/user';
import userVariantTest, { type State as userVariantTestState } from './modules/userVariantTest';
import video, { type State as videoState } from './modules/video';
import viewData, { type State as viewDataState } from './modules/viewData';
import waitingForApproval, { type State as waitingForApprovalState } from './modules/waitingForApproval';
import whiteLabel, { type State as whiteLabelState } from './modules/whiteLabel';
import windowSize, { type State as windowSizeState } from './modules/windowSize';
import wonItems, { type State as wonItemsState } from './modules/wonItems';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import errors from './modules/errors';
import type { RouterHistory } from 'react-router';

export default (history: RouterHistory) =>
    combineReducers({
        about,
        absenteeBid,
        addSearchAlert,
        analytics,
        autoPopModal,
        bidCountDown,
        bidderBiddingInfoAll,
        bidderBiddingInfoUpcoming,
        bidderExists,
        biddingInfo,
        bidHistory,
        bidIncrements,
        bidLimit,
        bidLimitExceeded,
        browser,
        buyNow,
        catalog,
        catalogAd,
        catalogCurators,
        catalogDetail,
        catalogFeatured,
        catalogItems,
        catalogLocation,
        catalogRegistration,
        catalogSearch,
        category,
        changePassword,
        checkout,
        cityStateSuggestion,
        codex,
        completeAccount,
        config,
        confirmPassword,
        consent,
        consignment,
        console,
        consoleBranding,
        consoleMessages,
        coverLots,
        createAccount,
        creditCard,
        curatedCollection,
        currency,
        emailList,
        errors,
        escrow,
        featuredCategories,
        feedback,
        fetchBatch,
        followSeller,
        forgotPassword,
        globalNotification,
        googleOptimize,
        healthcheck,
        home,
        imageGalleryActiveImage,
        intl,
        item,
        itemDetail,
        itemFacets,
        itemShipping,
        landingPage,
        listingAgent,
        liveBid,
        liveCatalogStatus,
        liveItemStatus,
        loaded,
        location,
        login,
        makeOffer,
        modal,
        moreItemsFromCatalogIndex,
        notification,
        pagination: paginationCookiesReducer,
        passwordReset,
        payment,
        paymentCustomer,
        persist: combineReducers({
            headerSearchDropdown,
            pagination: paginationLocalStorageReducer,
        }),
        recentItem,
        recommendedItem,
        registerForCatalog,
        retractBid,
        review,
        reviewStatus,
        route,
        router: connectRouter(history),
        savedItemCount,
        savedSearch,
        savedSearchItem,
        saveItem,
        saveSearch,
        saveSearchCheck,
        search,
        searchExclusions,
        searchFacets,
        searchPromoted,
        searchSuggestions,
        seller,
        sellerCatalogCounts,
        sellerDetail,
        sellerEndedCatalogs,
        sellerFollowerCount,
        sellerPreviewCatalogs,
        sellerRatings,
        sellerRecordResults,
        sellerUpcomingCatalogs,
        sendSellerMessage,
        setPassword,
        shim,
        shipping,
        shouldLogin,
        similarItems,
        similarItemsV3,
        storefront,
        stripe,
        topRatedSellers,
        trustMetrics,
        upcomingCatalogs,
        upcomingItems,
        updateAccount,
        user,
        userVariantTest,
        video,
        viewData,
        waitingForApproval,
        whiteLabel,
        windowSize,
        wonItems,
    });

export type GlobalState = {|
    about: aboutState,
    absenteeBid: absenteeBidState,
    addSearchAlert: addSearchAlertState,
    analytics: analyticsState,
    autoPopModal: autoPopModalState,
    bidCountDown: bidCountDownState,
    bidderBiddingInfoAll: bidderBiddingInfoAllState,
    bidderBiddingInfoUpcoming: bidderBiddingInfoUpcomingState,
    bidderExists: bidderExistsState,
    biddingInfo: biddingInfoState,
    bidHistory: bidHistoryState,
    bidIncrements: bidIncrementsState,
    bidLimit: bidLimitState,
    bidLimitExceeded: bidLimitExceededState,
    browser: browserState,
    buyNow: buyNowState,
    catalog: catalogState,
    catalogAd: catalogAdState,
    catalogCurators: catalogCuratorsState,
    catalogDetail: catalogDetailState,
    catalogFeatured: catalogFeaturedState,
    catalogItems: catalogItemsState,
    catalogLocation: catalogLocationState,
    catalogRegistration: catalogRegistrationState,
    catalogSearch: catalogSearchState,
    category: categoryState,
    changePassword: changePasswordState,
    checkout: checkoutState,
    cityStateSuggestion: cityStateSuggestionState,
    codex: codexState,
    completeAccount: completeAccountState,
    config: configState,
    confirmPassword: confirmPasswordState,
    consent: consentState,
    consignment: consignmentState,
    console: consoleState,
    consoleBranding: consoleBrandingState,
    consoleMessages: consoleMessagesState,
    coverLots: coverLotsState,
    createAccount: createAccountState,
    creditCard: creditCardState,
    curatedCollection: curatedCollectionState,
    currency: currencyState,
    emailList: emailListState,
    escrow: escrowState,
    featuredCategories: featuredCategoriesState,
    feedback: feedbackState,
    fetchBatch: fetchBatchState,
    followSeller: followSellerState,
    forgotPassword: forgotPasswordState,
    globalNotification: globalNotificationState,
    googleOptimize: googleOptimizeState,
    healthcheck: healthcheckState,
    home: homeState,
    imageGalleryActiveImage: imageGalleryActiveImageState,
    intl: intlState,
    item: itemState,
    itemDetail: itemDetailState,
    itemFacets: itemFacetsState,
    itemShipping: itemShippingState,
    landingPage: landingPageState,
    listingAgent: listingAgentState,
    liveBid: liveBidState,
    liveCatalogStatus: liveCatalogStatusState,
    liveItemStatus: liveItemStatusState,
    loaded: loadedState,
    location: locationState,
    login: loginState,
    makeOffer: makeOfferState,
    modal: modalState,
    moreItemsFromCatalogIndex: moreItemsFromCatalogIndexState,
    notification: notificationState,
    passwordReset: passwordResetState,
    payment: paymentState,
    paymentCustomer: paymentCustomerState,
    persist: {
        headerSearchDropdown: headerSearchDropdownState,
    },
    recentItem: recentItemState,
    recommendedItem: recommendedItemState,
    registerForCatalog: registerForCatalogState,
    retractBid: retractBidState,
    review: reviewState,
    reviewStatus: reviewStatusState,
    route: routeState,
    savedItemCount: savedItemCountState,
    savedSearch: savedSearchState,
    savedSearchItem: savedSearchItemState,
    saveItem: saveItemState,
    saveSearch: saveSearchState,
    saveSearchCheck: saveSearchCheckState,
    search: searchState,
    searchExclusions: searchExclusionsState,
    searchFacets: searchFacetsState,
    searchPromoted: searchPromotedState,
    searchSuggestions: searchSuggestionsState,
    seller: sellerState,
    sellerCatalogCounts: sellerCatalogCountsState,
    sellerDetail: sellerDetailState,
    sellerEndedCatalogs: sellerEndedCatalogsState,
    sellerFollowerCount: sellerFollowerCountState,
    sellerPreviewCatalogs: sellerPreviewCatalogsState,
    sellerRatings: sellerRatingsState,
    sellerRecordResults: sellerRecordResultsState,
    sellerUpcomingCatalogs: sellerUpcomingCatalogsState,
    sendSellerMessage: sendSellerMessageState,
    setPassword: setPasswordState,
    shim: shimState,
    shipping: shippingState,
    shouldLogin: shouldLoginState,
    similarItems: similarItemsState,
    similarItemsV3: similarItemsV3State,
    storefront: storefrontState,
    stripe: stripeState,
    topRatedSellers: topRatedSellersState,
    trustMetrics: trustMetricsState,
    upcomingCatalogs: upcomingCatalogsState,
    upcomingItems: upcomingItemsState,
    updateAccount: updateAccountState,
    user: userState,
    userVariantTest: userVariantTestState,
    video: videoState,
    viewData: viewDataState,
    waitingForApproval: waitingForApprovalState,
    whiteLabel: whiteLabelState,
    windowSize: windowSizeState,
    wonItems: wonItemsState,
|};
